module.exports = __webpack_public_path__ + "img/ageas.f0bd04f8.png";